import { Autocomplete, Button, Input, MenuItem, Select, TextField, Typography } from '@mui/material';
import { Spinner } from 'components/design';
import { ValidationSchemaType, useForm } from 'hooks/useForm';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import OWContainer from 'styles/styled-components/ow-container';

const testData = {
    name: '',
    email: 'email@gmail.com',
    age: 20,
    sex: 'male',
    autocomplete: 'test',
};

const testSchema: ValidationSchemaType<typeof testData> = {
    name: {
        required: true,
    },
    email: {
        required: true,
        type: 'email',
    },
    age: {
        type: 'number',
        min: 18,
    },
    sex: {
        required: true,
    },
};

const autocompleteOptions = [
    {
        label: 'option1',
        id: '1',
    },
    {
        label: 'option2',
        id: '2',
    },
];

export const ProfileRoute = () => {
    const { t } = useTranslation();
    const { formData, setInitialFormData, handleChange, handleSubmit } = useForm({
        validationSchema: testSchema,
    });

    useEffect(() => {
        setInitialFormData(testData);
    }, [setInitialFormData]);

    return (
        <OWContainer>
            {formData ? (
                <>
                    <Typography variant="h3">{t('PROFILE_PAGE.TITLE')}</Typography>
                    <Input
                        value={formData.name}
                        placeholder="name"
                        name="name"
                        onChange={(e) => handleChange('name', e.target.value)}
                    />
                    <Input
                        value={formData.email}
                        placeholder="email"
                        name="email"
                        onChange={(e) => handleChange('email', e.target.value)}
                    />
                    <Input
                        value={formData.age}
                        placeholder="age"
                        name="age"
                        onChange={(e) => handleChange('age', e.target.value)}
                    />
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={formData.sex}
                        label="Sex"
                        name="sex"
                        onChange={(e) => handleChange('sex', e.target.value)}
                    >
                        <MenuItem value={'unspecified'}>unspecified</MenuItem>
                        <MenuItem value={'male'}>male</MenuItem>
                        <MenuItem value={'female'}>female</MenuItem>
                    </Select>
                    <Autocomplete
                        disablePortal
                        options={autocompleteOptions}
                        renderInput={(params) => <TextField {...params} label="Movie" />}
                        onChange={(_, value) => handleChange('autocomplete', value)}
                    />
                    <Button type="submit" onClick={() => handleSubmit(() => console.log('test!!'))}>
                        Submit
                    </Button>
                </>
            ) : (
                <Spinner />
            )}
        </OWContainer>
    );
};
